import { render } from "./claim_raise.vue?vue&type=template&id=a7afb0c6&scoped=true"
import script from "./claim_raise.vue?vue&type=script&lang=js"
export * from "./claim_raise.vue?vue&type=script&lang=js"

import "./claim_raise.vue?vue&type=style&index=0&id=a7afb0c6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7afb0c6"]])

export default __exports__